import { render, staticRenderFns } from "./PendingContributionsReport.vue?vue&type=template&id=3c784bf7&scoped=true"
import script from "./PendingContributionsReport.vue?vue&type=script&lang=ts"
export * from "./PendingContributionsReport.vue?vue&type=script&lang=ts"
import style0 from "./PendingContributionsReport.vue?vue&type=style&index=0&id=3c784bf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c784bf7",
  null
  
)

export default component.exports